<script setup>
import lang from '../lang.json'
import { ref, defineProps } from 'vue'

const GoogleFormLink = {
  id: 'https://docs.google.com/forms/d/e/1FAIpQLSdXDAP0jgyHYehYqlQ8zT92WStyBzTZl9y2lXa925Tj74EWTg/viewform?usp=dialog',
  vi: 'https://docs.google.com/forms/d/e/1FAIpQLSfkxPtB_6MO7nxGuV7wTGIz6MnuQDrK77IwUxrtSi9_nyKcfQ/viewform?usp=header',
  en: 'https://docs.google.com/forms/d/e/1FAIpQLScey9Ti46SGlBcxy6xOIGJGaZmQRbK548O5S4e5K5degwsasw/viewform?usp=header',
  es: 'https://docs.google.com/forms/d/e/1FAIpQLSdmloFxxuWhXdfXOWVpKNLGHsDdlchvUBlXBLxFit2TmdM-DA/viewform?usp=header'
}

const props = defineProps({
  local: {
    type: String,
    default: navigator.language.split('-')[0]
  }
})
const languages = new Proxy(lang, {
  get: function (target, property) {
    if (target[property]) {
      return target[property][props.local] || target[property].en
    }
    return ''
  }
})

const visible = ref(true)
const closeBar = (e) => {
  e.stopPropagation()
  e.preventDefault()
  visible.value = false
}

/**
 * 跳转 google form
 * */
const toGoogleForm = () => {
  window.location.href = GoogleFormLink[props.local]
}
</script>

<template>
  <div v-if="visible" class="googleMapWrapper" @click="toGoogleForm">
    <div class="left">
      <img src="../assets/closeIcon.png" alt="" @click="closeBar" />
      {{ languages.i_help_improve_timemark }}
    </div>
    <div class="bar-right">
      <img
        :style="{ height: '28px', width: '28px' }"
        src="../assets/rightArrow.png"
        alt=""
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.googleMapWrapper {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background: #8fcaf2;
  font-weight: 590;
  font-size: 14px;
  color: #144672;

  .left {
    display: flex;
    align-items: center;

    img {
      width: 20px;
      height: 20px;
      margin-top: 1px;
      margin-right: 12px;
    }
  }
}
</style>
